import 'bootstrap/dist/css/bootstrap.min.css';
import Loader from './Loader/Loader';
import React, { useState, useEffect } from 'react';
import { subIDArray } from './subids';

function App() {
  const [loading, setLoading] = useState(null);

  const BINOM_CAMPAIGN_URL = 'https://cpa.sweepmob.com/c1kgl9k.php?key=jnk9f9uvagxjoy6am6lp';

  // Redirects user after 0 seconds
  useEffect(() => {
    setLoading(true);

    // Pick a random subID from the subIDArray
    const pickRandomFromArray = subIDArray[Math.floor(Math.random() * subIDArray.length)];

    setTimeout(() => {
      window.location.replace(`${BINOM_CAMPAIGN_URL}&websiteid=${pickRandomFromArray}`);
      setLoading(true);
    }, 1);
  }, []);

  return (
    <div className="App">
      <br />
      <br />
      <br />
      <br />
      {loading ? (
        <div>
          <Loader />{' '}
        </div>
      ) : (
        <button className="toprewards-btn-getit">CONTINUE 👉</button>
      )}
    </div>
  );
}

export default App;
